import { HttpInterceptor, HttpRequest, HttpHandler } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { AuthenticationService } from '../_servicios/authentication.service';
import { environment } from 'environments/environment';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {

    constructor(
        private AuthenticationService: AuthenticationService,
        private router: Router
        ) { }

    intercept(req: HttpRequest<any>, next: HttpHandler) {
        const authToken = this.AuthenticationService.getToken;
        const currentUser = this.AuthenticationService.currentUserValue;
        const userId = currentUser?.id;
        const userName = currentUser ? (currentUser.lastName ? `${currentUser.name} ${currentUser.lastName}` : currentUser.name) : undefined;

        // Only attach withCredentials for requests targeting the primary LIMS backend (where session cookies are scoped).
        // Cross-domain calls (e.g. api-gateway, external services) authenticate via Bearer token
        // and setting withCredentials causes browsers to block responses with Access-Control-Allow-Origin: *
        const isLimsBackend = (!req.url.startsWith('http://') && !req.url.startsWith('https://'))
            || (!!environment.apiUrl && req.url.startsWith(environment.apiUrl))
            || (!!environment.graphqlUrl && req.url.startsWith(environment.graphqlUrl));

        const shouldIncludeCredentials = req.withCredentials || isLimsBackend;

        const authRequest = req.clone({
            withCredentials: shouldIncludeCredentials,
            headers: req.headers
                        .set('Authorization', "Bearer " + authToken)
                        .set('Hostname', window.location.hostname)
                        .set('x-user-id', userId ? String(userId) : '')
                        .set('x-user-name', userName ? String(userName) : '')
        });
        return next.handle(authRequest);
    }
}